/**
* RegisterLanguagePackCommand.js
* 
* Created on 14-mei-2014, 14:05:57
*
* @author Ivo Swartjes for Ranj
**/
export default class RegisterLanguagePackCommand {

    constructor(languagePackRegistry) {
        this.execute = function(event) {
            languagePackRegistry.registerLanguagePack(event.params.data.languagePack, event.params.data.lpAssetURL);
        };
    };

}